module.exports = __webpack_public_path__ + "static/media/trainingPlayfulIcon.10a19365.png";